"use client";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { podcastInterviews as data } from "@/lib/data/press";

const accent = "var(--color-amber)";

export function PodcastInterviews() {
  return (
    <Section id="podcast-interviews" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-amber)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            {data.intro ? <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p> : null}
          </div>
        </Reveal>
        <div className="mt-12 grid gap-5" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))" }}>
{data.pillars?.map((p, i) => (
            <Reveal key={i} delay={i * 80}>
              <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-3">{p.title}</h3>
                <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
        {"cta" in data && Array.isArray(data.cta) ? (
          <Reveal delay={500}>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              {data.cta.map((c, i) => (
                <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                  {c.label} <ArrowRight className="h-3.5 w-3.5" />
                </Link>
              ))}
            </div>
          </Reveal>
        ) : null}
      </Container>
    </Section>
  );
}
